(function () {
  'use strict';

  var popup    = document.getElementById('search-popup');
  var overlay  = popup ? popup.querySelector('.search-popup__overlay') : null;
  var input    = document.getElementById('search-input');
  var submit   = document.getElementById('search-submit');
  var closeBtn = document.getElementById('search-close');
  var results  = document.getElementById('search-results');
  var openBtn  = document.getElementById('search-open');

  if (!popup || !input) return;

  var debounceTimer = null;
  var currentQuery  = '';

  function updateHeaderBottom() {
    var header = document.querySelector('.site-header');
    if (!header || !popup.classList.contains('is-open')) return;
    var rect = header.getBoundingClientRect();
    popup.style.setProperty('--header-bottom', rect.bottom + 'px');
  }

  /* ---- Open / close ---- */
  function openPopup() {
    popup.classList.add('is-open');
    popup.removeAttribute('aria-hidden');
    document.body.classList.add('search-popup-open');
    document.documentElement.classList.add('search-popup-open');
    var header = document.querySelector('.site-header');
    if (header) header.classList.add('is-search-open');
    updateHeaderBottom();
    requestAnimationFrame(function () {
      updateHeaderBottom();
    });
    setTimeout(function () { input.focus(); }, 50);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-popup-open');
    document.documentElement.classList.remove('search-popup-open');
    var header = document.querySelector('.site-header');
    if (header) header.classList.remove('is-search-open');
    
    // Clear search data after transition completes (250ms)
    setTimeout(function () {
      if (!popup.classList.contains('is-open')) {
        input.value = '';
        currentQuery = '';
        results.innerHTML = '';
      }
    }, 250);
  }

  if (openBtn)  openBtn.addEventListener('click', openPopup);
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (overlay)  overlay.addEventListener('click', closePopup);

  window.addEventListener('scroll', updateHeaderBottom, { passive: true });
  window.addEventListener('resize', updateHeaderBottom, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  /* ---- Navigate to search page ---- */
  function goToSearch() {
    var q = input.value.trim();
    if (!q) return;
    window.location.href = '/search?q=' + encodeURIComponent(q + '*') + '&type=product&options[prefix]=last';
  }

  if (submit) submit.addEventListener('click', goToSearch);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') goToSearch();
  });

  /* ---- Predictive search ---- */
  input.addEventListener('input', function () {
    var q = input.value.trim();

    clearTimeout(debounceTimer);

    if (q.length < 3) {
      results.innerHTML = q.length > 0
        ? '<p class="search-popup__hint">Type at least 3 characters…</p>'
        : '';
      return;
    }

    if (q === currentQuery) return;

    debounceTimer = setTimeout(function () {
      fetchPredictions(q);
    }, 300);
  });

  function fetchPredictions(q) {
    currentQuery = q;
    showLoading();

    var isMobile = window.innerWidth < 768;
    var limit = isMobile ? 4 : 6;

    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product'
      + '&resources[limit]=' + limit
      + '&resources[options][fields]=title,variants.title,body'
      + '&resources[options][unavailable_products]=hide';

    fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(function (data) {
        var products = data.resources
          && data.resources.results
          && data.resources.results.products
          ? data.resources.results.products
          : [];
        
        if (isMobile) {
          products = products.slice(0, 4);
        }
        
        renderResults(products, q);
      })
      .catch(function () {
        results.innerHTML = '<p class="search-popup__hint">Something went wrong. Try again.</p>';
      });
  }

  function showLoading() {
    results.innerHTML = '<div class="search-popup__loading">'
      + '<span class="search-popup__spinner"></span>'
      + '<span>Searching…</span>'
      + '</div>';
  }

  function renderResults(products, q) {
    if (products.length === 0) {
      results.innerHTML = '<p class="search-popup__hint">No products found for "<strong>' + escapeHtml(q) + '</strong>".</p>';
      return;
    }

    var html = '<p class="search-popup__label">Products</p>'
      + '<div class="search-popup__grid">';

    products.forEach(function (product) {
      var imgHtml;

      if (product.featured_image && product.featured_image.url) {
        var imgUrl = product.featured_image.url
          .replace(/(\.[a-z]+)(\?|$)/, '_400x400$1$2');
        imgHtml = '<img'
          + ' src="' + imgUrl + '"'
          + ' alt="' + escapeHtml(product.featured_image.alt || product.title) + '"'
          + ' class="search-product__img"'
          + ' loading="lazy"'
          + ' width="400" height="400"'
          + '>';
      } else {
        imgHtml = '<div class="search-product__img-placeholder">'
          + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
          + '<rect x="3" y="3" width="18" height="18" rx="2"/>'
          + '<circle cx="8.5" cy="8.5" r="1.5"/>'
          + '<polyline points="21 15 16 10 5 21"/>'
          + '</svg>'
          + '</div>';
      }

      var price = product.price
        ? formatMoney(product.price)
        : '';

      html += '<a href="' + product.url + '" class="search-product">'
        + '<div class="search-product__img-wrap">' + imgHtml + '</div>'
        + '<div class="search-product__info">'
        + '<span class="search-product__title">' + escapeHtml(product.title) + '</span>'
        + (price ? '<span class="search-product__price">' + price + '</span>' : '')
        + '</div>'
        + '</a>';
    });

    html += '</div>';

    /* "See all results" link */
    html += '<a href="/search?q=' + encodeURIComponent(q + '*') + '&type=product&options[prefix]=last" class="search-popup__see-all">'
      + 'See all results'
      + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
      + '</a>';

    results.innerHTML = html;
  }

  /* ---- Helpers ---- */
  function formatMoney(cents) {
    var amount = Math.round(cents);
    return 'Rp' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
